import React from 'react'
import CspUserDetail from 'src/app/CspUserDetail/CspUserDetail'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { cspUserDetailRouteProps } from 'src/navigation/routeProps'

const CspUserDetailAppRoute: AppRoute = {
  routeProps: cspUserDetailRouteProps,
  component: <CspUserDetail />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default CspUserDetailAppRoute
